import { formatInTimeZone } from "./datetime";

export function formatShortDate(value, timeZone) {
  if (!value) return "";
  if (timeZone) {
    const formatted = formatInTimeZone(
      value,
      timeZone,
      {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      "en-US"
    );
    if (formatted && formatted !== "-") {
      return formatted;
    }
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString();
}
